// eslint-disable-next-line no-unused-vars
const EARNINGS_COMMAND_PKG = {
    navTitle: "Earnings",
    routerName: "EarningsDocs",
    commandsDescription: "Next ER, Estimates, Reports, etc...",

    commandList : [
        {
            title: "Earnings List",
            routerRef: "earnings",
            commandString: "!earnings <today>",
            description: "List of Stocks with Earnings",
            parameters: [
                { name: "today", desc: "Stocks Earnings for Today" },
                { name: "tomorrow", desc: "Stock Earnings for Tomorrow" },
            ],
            examples: [
                "!earnings today",
                "!earnings tomorrow"
            ],
            type: "Earnings", 
            shortcuts: ["none"]
        },
        {
            title: "Earnings Report",
            routerRef: "erreport",
            commandString: "!erreport <Symbol>",
            description: "Gives description of last earnings for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want" },
            ],
            examples: [
                "!erreport GOOGL",
                "!erreport AMD"
            ],
            type: "Earnings", 
            shortcuts: ["none"]
        },
        {
            title: "Next Stock Earnings Date",
            routerRef: "nexter",
            commandString: "!nexter <Symbol>",
            description: "Gives next ER for a stock AMC=After Market Close BMO=Before Market Open",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!nexter GOOGL",
                "!nexter AMD"
            ],
            type: "Earnings", 
            shortcuts: ["none"]
        },
        {
            title: "Earnings Data",
            routerRef: "erdata",
            commandString: "!erdata <Symbol>",
            description: "Returns the last 2 years of moves for Earnings Data",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!erdata GOOGL",
                "!erdata AMD"
            ],
            type: "Earnings", 
            shortcuts: ["none"]
        },
        {
            title: "Earnings Estimate",
            routerRef: "erest",
            commandString: "!erest <Symbol>",
            description: "Earnings Estimate from EarningsWhisper",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!erest GOOGL",
                "!erest AMD"
            ],
            type: "Earnings", 
            shortcuts: ["none"]
        },
        {
            title: "Earnings Move",
            routerRef: "ermove",
            commandString: "!ermove <Symbol>",
            description: "See implied move for a stock based on option prices",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!ermove GOOGL",
                "!ermove AMD"
            ],
            type: "Earnings", 
            shortcuts: ["none"]
        },
        {
            title: "Last Earnings",
            routerRef: "laster",
            commandString: "!laster <Symbol>",
            description: "Info on the last ER of the company",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!laster GOOGL",
                "!laster AMD"
            ],
            type: "Earnings", 
            shortcuts: ["none"]
        }
    ]
}


export {EARNINGS_COMMAND_PKG};